export default {
  MODULE: "Module",
  NAME: "Nom",
  VALUE: "Valeur",
  MODULE_GENERAL: "Général",
  OPTION_DOCUMENT_FOOTER: "Pied de page des document",
  OPTION_DEFAULT_TAXES_GROUP: "Groupe de taxes par défaut",
};
